import { Stack } from "@mui/material";
import { IconButton } from "@src/appV2/redesign/components/IconButton";
import { AccountSwitcherMobile } from "../AccountSwitcher/AccountSwitcher";

export interface NavigtionMenuHeaderMobileProps {
  onClose: () => void;
}

export function NavigationMenuHeaderMobile(props: NavigtionMenuHeaderMobileProps) {
  const { onClose } = props;

  return (
    <Stack direction="row" gap={5} alignItems="center" flexGrow={0} flexShrink={0}>
      <AccountSwitcherMobile />
      <IconButton
        variant="outlineInverted"
        iconType="close"
        size="large"
        onClick={onClose}
      ></IconButton>
    </Stack>
  );
}
